export default "__VITE_ASSET__K0eTyJ3K__"